import apiService from './api';
import { Customer, CreateCustomerData, UpdateCustomerData } from '../types/customerTypes';

class CustomerService {
  async getCustomers(): Promise<Customer[]> {
    const response = await apiService.get<Customer[]>('/customers');
    return response.data;
  }

  async getCustomer(id: string): Promise<Customer> {
    const response = await apiService.get<Customer>(`/customers/${id}`);
    return response.data;
  }

  async createCustomer(data: CreateCustomerData): Promise<Customer> {
    const response = await apiService.post<Customer>('/customers', data);
    return response.data;
  }

  async updateCustomer(data: UpdateCustomerData): Promise<Customer> {
    const response = await apiService.put<Customer>(`/customers/${data.id}`, data);
    return response.data;
  }

  async deleteCustomer(id: string): Promise<void> {
    await apiService.delete(`/customers/${id}`);
  }

  async searchCustomers(query: string): Promise<Customer[]> {
    const response = await apiService.get<Customer[]>('/customers/search', {
      params: { q: query }
    });
    return response.data;
  }

  async getActiveCustomers(): Promise<Customer[]> {
    const response = await apiService.get<Customer[]>('/customers/active');
    return response.data;
  }
}

export const customerService = new CustomerService();
export default customerService; 